/* This file is autogenerated, see readme.md for instructions */
import BooleanSvgIcon from '@bloomreach/banana-theme/icons/boolean.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const BooleanIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <BooleanSvgIcon />
    </Icon>
  );
});

BooleanIcon.displayName = 'BooleanIcon';

export default BooleanIcon;
